<template>
    <DialogLayout>
        <form @submit.prevent="handleSubmit">
            <h3 class="Modal__title">Contactez-nous</h3>
            <p class="Modal__text">Cette annonce vous intéresse ? Contactez-nous afin que nous puisson en discuter.</p>
            <div class="Alert Alert--error m-b-15" v-if="errorOccured">
                Une erreur est survenue, veuillez réessayer.
            </div>
            <div class="row">
                <div class="col-md-4">
                    <input-material @input="value => handleChange('name', value)" :required="true" label="Nom"
                                    :error="errors.name" v-model="data.name"/>
                </div>
                <div class="col-md-4">
                    <input-material @input="value => handleChange('email', value)" :required="true"
                                    label="Adresse e-mail" type="email" :error="errors.email"
                                    v-model="data.email"/>
                </div>
                <div class="col-md-4">
                    <input-material @input="value => handleChange('phone', value)" label="Téléphone"
                                    :error="errors.phone" v-model="data.phone"/>
                </div>
            </div>
            <input-material @input="value => handleChange('message', value)" :required="true" label="Message"
                            :error="errors.message" v-model="data.message"
                            type="textarea"/>
            <div class="text-center m-t-30">
                <button :disabled="sending" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="sending" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Envoyer <i class="fas fa-caret-right m-l-5"></i></span>
                </button>
            </div>
        </form>
    </DialogLayout>
</template>
<script>
    import InputMaterial from "../../InputMaterial";
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import {actions, getters} from "../../../store";
    import DialogLayout from "../Layouts/DialogLayout";
    import validate from "../../../validator/validator";
    import Rules from "../../../validator/rules";
    import {isEmpty} from "../../../utils";
    import Api from "../../../services/Api";
    import ModalBus from "../../../eventBus";
    import Token from "../../../services/Token";

    export default {
        components: {DialogLayout, InputMaterial, Multiselect},
        props: {
            ad: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {
                sending: false,
                errorOccured: false,
                data: {
                    name: null,
                    phone: null,
                    email: null,
                    message: null
                },
                errors: {}
            }
        },
        watch: {
            ad: function () {
                this.setTemplate();
            }
        },
        methods: {
            setTemplate: function () {
                if (this.ad.type === 'LEARNER') {
                    this.data.message = "Bonjour,\n\nJe suis intéressé(e) par cette annonce d'apprenant, pouvez-vous me contacter ?\n\nCordialement";
                } else {
                    this.data.message = "Bonjour,\n\nJe suis intéressé(e) par cette annonce d'entreprise, pouvez-vous me contacter ?\n\nCordialement";
                }
            },
            handleChange: function (name) {
                delete this.errors[name];
            },
            handleSubmit: async function () {
                let {name, phone, email, message} = this.data,
                    data = {
                        name,
                        email,
                        phone,
                        message,
                        type: this.ad.type === 'LEARNER'
                            ? this.$enums.ContactType.LearnerAd
                            : this.$enums.ContactType.CompanyAd
                    },
                    errors = validate(data, {
                        name: [Rules.required()],
                        email: [Rules.required(), Rules.email()],
                        phone: [Rules.nullable(), Rules.phone()],
                        message: [Rules.required(), Rules.minLength(30)]
                    });

                this.errorOccured = false;

                if (!isEmpty(errors)) {
                    this.errors = errors;
                    return;
                }

                this.sending = true;

                try {
                    await this.$recaptchaLoaded();
                    data['g-recaptcha-response'] = await this.$recaptcha('contact');

                    await Api.post(`/announcements/${this.ad.code}/contact`, data);
                    ModalBus.alertSuccess('Message envoyé', 'Nous vous remercions de nous avoir contacté, votre message sera traité dans les meilleurs délais.');
                } catch (err) {
                    this.sending = false;
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                    } else {
                        this.errorOccured = true;
                    }
                }
            }
        },
        async created() {
            if(!this.$user && Token.has()){
                await actions.fetchUser();
            }

            this.data = {
                ...this.data,
                name: this.$user?.profile?.name,
                phone: this.$user?.profile?.phone,
                email: this.$user?.email
            };

            this.setTemplate();
        }
    }
</script>
